export default __webpack_public_path__ + "static/media/cad1.e1d9c539.png";